import {Pipe, PipeTransform} from "@angular/core";
import {EMPLOYER_STATUSES} from "../_maps/employer-statuses";

@Pipe({name: "employerStatus"})
export class EmployerStatusPipe implements PipeTransform {
  transform(status: string): any {
    return EMPLOYER_STATUSES[status];
  }
}
